import { render, staticRenderFns } from "./SideBarPage.vue?vue&type=template&id=39dc7d62&"
import script from "./SideBarPage.vue?vue&type=script&lang=js&"
export * from "./SideBarPage.vue?vue&type=script&lang=js&"
import style0 from "./SideBarPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports